import { render } from "./icon-phone.vue?vue&type=template&id=1af7b4c6"
import script from "./icon-phone.vue?vue&type=script&lang=js"
export * from "./icon-phone.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"assets/icons/icon-phone.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1af7b4c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1af7b4c6', __exports__)) {
    api.reload('1af7b4c6', __exports__)
  }
  
  module.hot.accept("./icon-phone.vue?vue&type=template&id=1af7b4c6", () => {
    api.rerender('1af7b4c6', render)
  })

}


export default __exports__